import { configureStore } from "@reduxjs/toolkit";
import { socketMiddleware } from "./socketMiddleware.js";

import authReducer from "./authSlice.js";
import registerReducer from "./registerSlice.js";
import roomsReducer from "./roomSlice.js";
import gameReducer from "./gameSlice.js";
import playerInfoReducer from "./playerInfoSlice.js";
import chatBoxReducer from "./chatBoxSilce.js";
import pupCatalogReducer from "./pupCatalogSlice.js";
import pupReducer from "./pupSlice.js";
import actionLogReducer from "./actionLogSlice.js";
import notificationsReducer from "./notificationsSlice.js";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    register: registerReducer,
    rooms: roomsReducer,
    games: gameReducer,
    playerInfo: playerInfoReducer,
    chatBox: chatBoxReducer,
    pupCatalog: pupCatalogReducer,
    pup: pupReducer,
    actionLog: actionLogReducer,
    notifications: notificationsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(socketMiddleware()),
});
